import type * as React from 'react';

import * as api from '@gitbook/api-client';
import { Picker, type PickerItemData } from '@gitbook/react-uikit';
import { FieldGroup, Label } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../types';

/**
 * Settings to configure the style for links
 */
export function ThemeLinksStyleSettings(props: SitesCustomizationPanelProps): React.ReactElement {
    const { settings, setSettings } = props;

    return (
        <FieldGroup orientation="horizontal">
            <Label>Link style</Label>
            <Picker
                value={settings.styling.links}
                items={OPTIONS}
                onValueChange={(value) => {
                    setSettings((prev) => ({
                        ...prev,
                        styling: {
                            ...prev.styling,
                            links: value,
                        },
                    }));
                }}
            />
        </FieldGroup>
    );
}

const OPTIONS: PickerItemData<api.CustomizationLinksStyle>[] = [
    {
        value: api.CustomizationLinksStyle.Default,
        label: 'Default',
        subtitle: 'Colored text and underline',
    },
    {
        value: api.CustomizationLinksStyle.Accent,
        label: 'Accent',
        subtitle: 'Colored underline only',
    },
];
